import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { navItems } from './sidebar-data';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [AppHorizontalNavItemComponent, NgIf, NgForOf, CommonModule],
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems = navItems;
  parentActive = '';

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public navService: NavService,
    public router: Router,
    private authService: AuthService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    if (this.authService.isAdminRoles()) {
      let adminNavItems: NavItem[] = [
        {
          displayName: 'Generale',
          children: [
            {
              displayName: 'Patient search',
              iconName: 'checklist',
              dontCheckPatientSelection: true,
              route: '/patients',
            },
            {
              displayName: 'Aggiungi paziente',
              iconName: 'ticket',
              dontCheckPatientSelection: true,
              route: '/patients/new-patient',
            },
            {
              displayName: 'Statistics',
              iconName: 'chart-pie',
              dontCheckPatientSelection: true,
              route: '/stats',
            },
          ],
        },
      ];
      navItems.push(...adminNavItems);
    }
  }
}
